<section class="grid gap-4">
  <div class="flex flex-wrap items-center justify-between gap-3">
    <div>
      <page-title [title]="'Affiliate details'"></page-title>
    </div>

    <div>
      <a mat-stroked-button routerLink="/affiliates">Back to affiliates</a>
    </div>
  </div>

  @if (affiliateStore.selectedAffiliate(); as affiliate) {
    <affiliate-form
      title="Update affiliate"
      submitLabel="Save changes"
      [busy]="affiliateStore.saving()"
      [initialValue]="affiliate"
      [readOnly]="!canUpdate()"
      [genders]="lookupStore.items('GENDER')"
      [languages]="lookupStore.items('LANGUAGE')"
      [religions]="lookupStore.items('RELIGION')"
      [affiliateDisciplines]="lookupStore.items('AFFILIATE_DISCIPLINE')"
        [provinces]="lookupStore.items('PROVINCE')"
      (submitted)="saveAffiliate($event)" />

    <history-list
      title="Affiliate history"
      emptyLabel="No history found for this affiliate."
      [history]="affiliateStore.history()" />
  } @else {
    <mat-card class="rounded-lg border border-slate-200 p-6 shadow-sm">
      <p class="text-slate-600">Loading affiliate details...</p>
    </mat-card>
  }
</section>
